<template>
    <div class="row">
        <div class="col-sm-12 col-md-6">
            <div class="form-label-group mb-0">
                <label class="pl-0"><span class="text-danger">*</span>Appointment Subject</label>
                <input type="text" name="subject" required id="" placeholder="Appointment Subject" class="form-control" v-model="item.subject">
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
            <div class="form-label-group mb-0">
            <label for="medium" class="pl-0"><span class="text-danger">*</span>Appointment Medium</label>
            <select type="text" v-model="item.appointment_medium" required name="medium" id="medium" class="form-control">
              <option value="" selected disabled>Choose medium</option>
              <option value="in_person">In Person</option>
              <option value="phone_call">Phone Call</option>
            </select>
            </div>
          </div>
        <div class="col-sm-12 col-md-6" v-if="item.appointment_medium === 'phone_call'">
            <div class="form-label-group mb-0">
                <label class="pl-0"><span class="text-danger">*</span>Phone Number</label>
                <telephone  ref="tel" v-model="item.phone_number"></telephone>
            </div>
        </div>
        <div class="col-sm-12 col-md-6" v-if="item.appointment_medium === 'in_person'">
            <div class="form-label-group mb-0">
                <label class="pl-0"><span class="text-danger">*</span>Location</label>
                <google_map @location_object="updated_location" :google_api_key="google_api"></google_map>
                <!-- <input type="text" name="subject" required id="" placeholder="Appointment Address" class="form-control" v-model="item.address"> -->
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
            <div class="form-label-group mb-0">
            <label for="appointment_type" class="pl-0"><span class="text-danger">*</span>Choose Type</label>
            <select type="text" v-model="item.appointment_type" required name="appointment_type" id="medium" class="form-control">
              <option value="" selected disabled>Choose medium</option>
              <option value="conssultation">Consultation</option>
              <option value="device_reparing">Device Reparing</option>
            </select>
            </div>
          </div>
        <div class="col-12">
            <div class="form-label-group mb-0" v-if="item.appointment_type === 'device_reparing'">
                <label class="pl-0">Device Description</label>
                <textarea name="detail" id="detail" placeholder="i.e: iPhone 15 Pro" class="form-contol" v-model="item.devices"></textarea>
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
            <div class="form-label-group mb-0">
                <label class="px-0"><span class="text-danger">*</span>Appointment Date and Time</label>
                <!-- <VueCtkDateTimePicker format="YYYY-MM-DD HH:mm" :no-value-to-custom-elem="false" color="#2E5FE3"
                    v-model="item.appointment_time">
                    <input type="text" id="appointment_time" class="form-control theme-input-field" style="height:2.8rem"
                        name="appointment_time" placeholder="Select DateTime" autocomplete="off" required />
                </VueCtkDateTimePicker> -->
                <input type="datetime-local" name="device" :readonly="disable_date" placeholder="" required id="device" class="form-control" v-model="item.appointment_time" v-bind:min="minDate">

            </div>
        </div>

        <div class="col-sm-12 col-md-6">
            <div class="form-label-group mb-0">
                <label><span class="text-danger">*</span>Appointment Duration</label>
                <input type="text" name="item_duration" :readonly="disable_date" placeholder="Appointment Duration" required id="device" class="form-control" v-model="item.duration">
            </div>
        </div>

        <div class="col-12">
            <div class="form-label-group">
                <label>Description (Any specific details to share with the technician for a better solution? )</label>
                <textarea name="detail" id="detail" placeholder="Appointment Description" class="form-contol" v-model="item.detail"></textarea>
            </div>
        </div>

        <div class="col-12">
            <div class="form-label-group">
                <label>Appointment Color</label>
                <input type="color" name="color" id="color" placeholder="Appointment Color" class="form-contol" v-model="item.color">
            </div>
        </div>

    </div>
</template>

<script>
import Select2 from 'v-select2-component';
import select_location from './../../reusable-components/select_location';
import select_customer_type from './../../reusable-components/user/customer_type';
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import submit_button from './../../reusable-components/submit_button';
import Telephone from '../../reusable-components/Telephone.vue';
import google_map from '../../reusable-components/google_map.vue';
export default {
    components: {
        Select2,
        select_location,
        Telephone,
        google_map,
        VueCtkDateTimePicker: VueCtkDateTimePicker,
    },
    props: {
        google_api:{default:null}
    },
    created() {
    },

    data() {
        return {
            disable_date:false,
            item: {
                appointment_time: null,
                detail: null,
                devices:null,
                duration: null,
                subject:null,
                color:null,
                appointment_medium:"",
                phone_number:null,
                address:null,
                appointment_type:""
            },
            minDate: new Date().toISOString().slice(0, 16),
        }
    },
    methods: {
        updated_location(address) {
            this.item.address = address;

        },
    }
}
</script>

